import Image from 'next/image';
import DefaultAvailabilitySvg from '@/assets/icons/default_availability.svg';
import { API_STATIC_FILES } from '@/utils/constants';
import type { AccessibilityCardProps } from './accessibilityCard.types';

export const AccessibilityCard = ({ name, icon }: AccessibilityCardProps) => {

  return (
    <div>
      {icon ? (
        <Image
          src={`${API_STATIC_FILES}${icon}`}
          alt="Иконка доступности"
          height={60}
          width={60}
        />
      ) : <DefaultAvailabilitySvg/>}
      <p>{name}</p>
    </div>
  );
};